import { schema } from 'normalizr'
import * as R from 'ramda'
import axios from 'axios'
import { cachePromise } from 'packages/cache-promise'

const resolveSchema = (autoSchema, ...entityArgs) => {
  if (typeof autoSchema === 'string') {
    const entityName = autoSchema.substring(1)
    return new schema.Entity(entityName, ...entityArgs)
  } else if (Array.isArray(autoSchema) && autoSchema.length === 1) {
    const [schema] = autoSchema
    return [resolveSchema(schema)]
  } else if (Array.isArray(autoSchema) && autoSchema.length > 1) {
    const [schema, definition, options] = autoSchema
    return resolveSchema(schema, resolveSchema(definition), options)
  } else if (typeof autoSchema === 'object') {
    return R.map(resolveSchema, autoSchema)
  }

  return autoSchema
}

const memoize = (fn) => {
  const cache = new Map()
  return (...args) => {
    const cacheKey = args[0]
    if (cache.has(cacheKey)) {
      return cache.get(cacheKey)
    } else {
      const result = fn(...args)
      cache.set(cacheKey, result)
      return result
    }
  }
}

const memoizedResolveSchema = memoize(resolveSchema)

export { memoizedResolveSchema as resolveSchema }

export const transformNumericKeyedObjectToArray = (object) => {
  if (object === 'undefined') {
    return undefined
  }

  if (object.constructor !== Object) {
    return object
  }

  const keys = Object.keys(object)
  const array = keys.filter((key) => Number.isInteger(+key)).map((key) => object[key])

  if (array.length > 0 && array.length === keys.length) {
    return array
  }

  return object
}

export function transformUndefinedToSpecialKey(object) {
  return JSON.parse(
    JSON.stringify(object, (k, v) => {
      if (v === undefined || v === 'undefined') {
        return '__noKey'
      }

      return v
    }).replace(/\bundefined\b/, '__noKey')
  )
}

let createOptions = () => ({})
export const setAxiosOptions = (_createOptions) => {
  if (typeof _createOptions !== 'function') {
    console.error('createOptions must be a function')
  }

  createOptions = _createOptions
}

const instance = axios.create()

export const getAxiosInstance = () => {
  const options = createOptions()
  Object.keys(options).forEach((key) => {
    const value = options[key]
    instance.defaults[key] = value
  })
  const shouldFetchWithCredentials = Boolean(process.env.REACT_APP_FETCH_WITH_CREDENTIALS)
  if (shouldFetchWithCredentials) {
    instance.defaults.withCredentials = true
  }
  return instance
}

export function mergeObjectOrReplaceArray(base, toMerge) {
  if (R.isNil(base)) {
    return toMerge
  } else if (Array.isArray(toMerge)) {
    return toMerge
  } else if (isObject(toMerge)) {
    return R.mergeDeepRight(base, toMerge)
  }

  return toMerge
}

export const isObject = (obj) => obj !== null && typeof obj === 'object'

export const getRequestMiddleware = {
  useCachePromise: true,
  callRequest,
}

function callRequest(promiseCreator, url) {
  if (getRequestMiddleware.useCachePromise) {
    return cachePromise(promiseCreator, url)
  }
  return promiseCreator()
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/connectApi/utils.js